// extracted by mini-css-extract-plugin
export var link = "QuickLinks-module--link--ecfad";
export var quicklink = "QuickLinks-module--quicklink--d5e84";
export var quicklinks = "QuickLinks-module--quicklinks--92c97";
export var vector = "QuickLinks-module--vector--f6d87";